// API Configuration
const getApiBaseUrl = () => {
  // For production builds, always use Firebase Functions URL
  if (process.env.NODE_ENV === 'production') {
    return 'https://us-central1-epoch-d2996.cloudfunctions.net/api';
  }
  
  // For development, use REACT_APP_API_URL if set, otherwise use local backend
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Default to local backend for development
  return 'http://localhost:3000/api';
};

const API_BASE_URL = getApiBaseUrl();



export const API_ENDPOINTS = {
  NEWS: `${API_BASE_URL}/news`,
  HEALTH: `${API_BASE_URL}/health`,
  NEWS_BRIEFING: `${API_BASE_URL}/news-briefing`,
  RECOMMEND_ARTICLES: `${API_BASE_URL}/recommend-articles`,
  SETUP_ALERTS: `${API_BASE_URL}/setup-alerts`,
  CHECK_ALERTS: (alertId) => `${API_BASE_URL}/check-alerts/${alertId}`,
  SUMMARIZE_ARTICLE: `${API_BASE_URL}/summarize-article`,
  ANALYZE_SENTIMENT: `${API_BASE_URL}/analyze-sentiment`,
  TRENDING_KEYWORDS: `${API_BASE_URL}/trending-keywords`,
  SEARCH: `${API_BASE_URL}/search`,
  SOURCES: `${API_BASE_URL}/sources`,
  AI_CHAT: `${API_BASE_URL}/ai-chat`,
  MCP: `${API_BASE_URL}/mcp`,
  STOCK_RATINGS: `${API_BASE_URL}/stock-ratings`,
  STOCK_NEWS: `${API_BASE_URL}/stock-news`,
  NEWS_SEARCH: `${API_BASE_URL}/api/news-search`,
  STOCK_SEARCH: `${API_BASE_URL}/stocks/search`,
  AI_STOCK_RECOMMENDATIONS: `${API_BASE_URL}/ai-stock-recommendations`,
  STOCK_DATA: `${API_BASE_URL}/stock-data`,
  AI_OPTIONS_RECOMMENDATIONS: `${API_BASE_URL}/ai-options-recommendations`,
  AI_ETF_RECOMMENDATIONS: `${API_BASE_URL}/ai-etf-recommendations`,
  BOOKS_AI_SUMMARY: `${API_BASE_URL}/books/ai-summary`,
  STOCKS_ADD: `${API_BASE_URL}/stocks/add`,
  STOCKS_DELETE: `${API_BASE_URL}/stocks/delete`,
  STOCKS_GET: (userId) => `${API_BASE_URL}/stocks/${userId}`,
  STOCKS_AI_INSIGHTS: `${API_BASE_URL}/stocks/ai-insights`,
  STOCKS_NEWS: (symbol) => `${API_BASE_URL}/stocks/news/${symbol}`,
  STOCKS_TOP_10: `${API_BASE_URL}/stocks/top-10`,
  
};

export default API_BASE_URL;
